import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getRevenueReport } from 'services/reports/revenue.service';

/**
 * Custom hook to fetch and cache the revenue report.
 * @param {Object} params - Query filter parameters
 * @returns {Object} React Query hook result
 */
export default function useRevenueReport(params) {
  return useQuery({
    queryKey: ['report', 'revenue', params],
    queryFn: () => getRevenueReport(params),
    placeholderData: keepPreviousData,
    staleTime: 30000, // 30 seconds cache stale time
    refetchOnWindowFocus: false
  });
}
